export default "__VITE_ASSET__794GxS3Q__"